import { useEffect } from 'react';
import { isNil } from 'lodash';

type AnalyticsWindow = Window & { CWC_MLCA?: { dataLayer: { actions?: unknown[]; pageInfo?: Record<string, unknown> } } };

export const useAnalyticsInit = () => {
  useEffect(() => {
    const win = window as AnalyticsWindow;
    const analyticsObject = win.CWC_MLCA;
    if (analyticsObject) {
      if (isNil(analyticsObject.dataLayer.actions)) {
        analyticsObject.dataLayer.actions = [];
      }
      // Init pageInfo to prevent corporate AEM scripts from crashing on undefined access
      if (isNil(analyticsObject.dataLayer.pageInfo)) {
        analyticsObject.dataLayer.pageInfo = {};
      }
    }
  }, []);
};
